import { Node } from "@tiptap/core";

export default Node.create({
  name: "customiframe",

  group: "block",
  content: "text*",

  addAttributes() {
    return {
      src: {
        default: null
      },
      allow: {
        default: null
      },
      allowFullscreen: {
        default: null
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "iframe[src]"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["iframe", HTMLAttributes, 0];
  }
});
